const x = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.949 17.949"><line class="cls-1" x1="0.75" y1="0.75" x2="17.199" y2="17.199"/><line class="cls-1" x1="17.199" y1="0.75" x2="0.75" y2="17.199"/></svg>';
const loupe = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><circle class="cls-1" cx="10" cy="10" r="9"/><line class="cls-1" x1="24" y1="24" x2="16.36" y2="16.36"/></svg>';

welcomeSlider();

$(window).scroll(function() {
  if($(window).scrollTop() > 100) {
    $('.header').addClass('sticky');
  } else {
    $('.header').removeClass('sticky');
  }
});

$('.nav__submenu > a').on('click', function(e) {
  e.preventDefault();
  if(!$(this).parent().hasClass('active')) {
    $(this).parent().addClass('active');
    $(this).next('ul').slideDown(500);
  } else {
    $(this).parent().removeClass('active');
    $(this).next('ul').slideUp(500);
  }
});

$('#search').on('click', function() {
  if(!$(this).hasClass('active')) {
    $(this).addClass('active');
    $(this).parent().addClass('active');
    $('.submenu__search').css("display", "flex").hide().fadeIn().addClass('active');
    $('.submenu__icon').html(x);
  } else {
    $(this).removeClass('active');
    $(this).parent().removeClass('active');
    $('.submenu__search').removeClass('active').delay(800).fadeOut();
    $('.submenu__icon').html(loupe);
  }
});

$('.hamburger').on('click', function() {
  if(!$(this).hasClass('hamburger--active')) {
    $(this).addClass('hamburger--active');
    $(this).parent().addClass('active');
    if($(window).width() > 575) {
      $('.nav').css("display", "flex").hide().fadeIn().addClass('active');
      $('.mask').fadeIn(800);
    } else {
      $('.nav').slideDown(600);
    }
  } else {
    $(this).removeClass('hamburger--active');
    $(this).parent().removeClass('active');
    if($(window).width() > 575) {
      $('.mask').fadeOut(600);
      $('.nav').removeClass('active').delay(800).fadeOut();
    } else {
      $('.nav').slideUp(600);
    }
  }
});

function welcomeSlider() {
  let i = 1;

  setInterval(function() {
    $('#no-' + i).css('opacity','0');
    if(i == 4) {
      $('#no-1').css('opacity','1');
    } else {
      $('#no-' + (i + 1)).css('opacity','1');
    }
    i++;
    (i > 4) ? i = 1 : i = i;
  }, 3000);
};
